export const LOAD_PPQ_DETAILS = "LOAD_PPQ_DETAILS";
export const CREATE_PPQ = "CREATE_PPQ";
